import { render } from "./view-product.vue?vue&type=template&id=d87a314e&scoped=true"
import script from "./view-product.vue?vue&type=script&lang=js"
export * from "./view-product.vue?vue&type=script&lang=js"

import "./view-product.vue?vue&type=style&index=0&id=d87a314e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87a314e"]])

export default __exports__